<template>
  <div class="button-progress">
    <button
      type="button"
      class="btn"
    >
      <IconProgressNotHanded
        width="18px"
        height="18px"
      />
    </button>
  </div>
</template>

<script>
import IconProgressNotHanded from "@/components/atoms/icons/IconProgressNotHanded.vue"

export default {
  name: "ButtonProgress",
  components: {
    IconProgressNotHanded,
  },
}
</script>